export const ADMIN_TOKEN_BACKUP_KEY = 'socialbox_admin_token_backup'

export function hasAdminTokenBackup() {
  try {
    return Boolean(sessionStorage.getItem(ADMIN_TOKEN_BACKUP_KEY))
  } catch {
    return false
  }
}

export function readAdminTokenBackup() {
  try {
    return sessionStorage.getItem(ADMIN_TOKEN_BACKUP_KEY) || null
  } catch {
    return null
  }
}
